import React from 'react';
import styled, { css } from 'styled-components';

const NormativaArgentina = ({ device }) => {
  return (
    <Container device={device}>
      <div>
        Defensa de las y los Consumidores.
        <br />
        Para reclamos ingrese
        <a
          href='https://www.argentina.gob.ar/produccion/defensadelconsumidor/formulario%20'
          title='Defensa al consumidor'
          target='_blank'
          rel='noopener noreferrer'
        >
          aquí.
        </a>
      </div>
      <div>
        Dirección General de Defensa y Protección al Consumidor.
        <br />
        Para consultas y/o denuncias ingrese
        <a
          href='https://buenosaires.gob.ar/tramites/denuncia-digital-defensa-al-consumidor'
          title='Defensa al consumidor'
          target='_blank'
          rel='noopener noreferrer'
        >
          aquí.
        </a>
      </div>
      <div>
        Normativa de Defensa del Consumidor.
        <br />
        Para consultas ingrese
        <a
          href='https://www.argentina.gob.ar/produccion/consumidor/leyes'
          title='Defensa al consumidor'
          target='_blank'
          rel='noopener noreferrer'
        >
          aquí.
        </a>
        <br />
        E-mail:
        <a
          href='mailto:consultas@consumidor.gob.ar'
          title='Defensa al consumidor'
          target='_blank'
          rel='noopener noreferrer'
        >
          consultas@consumidor.gob.ar
        </a>
      </div>
      <div>
        <a
          href='https://help.zonaprop.com.ar/s/article/Contratos-de-adhesi%C3%B3n-Ley-N-24-240-de-Defensa-del-Consumidor'
          title='Defensa al consumidor zonaprop'
          target='_blank'
          rel='noopener noreferrer'
          style={{ margin: 'unset' }}
        >
          Contratos de adhesión - Ley N° 24.240 de Defensa del Consumidor.
        </a>
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-top: 30px;
  > div {
    max-width: 270px;
    white-space: break-spaces;
    line-height: 14px;
  }
  a {
    color: black;
    margin: 0 4px;
  }
  ${({ device }) =>
    device === 'mobile' &&
    css`
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 14px;
      margin-top: 24px;
      > div {
        max-width: 350px;
      }
    `}
`;

export default NormativaArgentina;
